import React from 'react';
import { reduce } from 'lodash';

import AppBlank from './app.blank';
import Screens from '../../screens';
import Logout from '../../screens/auth/logout';
import Search from '../../screens/search';
import WebSSOConnect from '../../components/app/websso/websso-connect';

import Admin from './app-admin';
import AlertManagement from './app-admin/alert-management';
import AlertList from './app-admin/alert-management/alert-list';

import Reports from '../../screens/reports/report-home';
import TransactionHistory from '../../screens/reports/transaction-history';

import Extender from './extender.route';
import maturityChildRoutes from '../../screens/maturities/maturities-asset';
import settings from "../../data/get-settings";
// RMCallBack
import RMCallBack from '../../screens/rmcallback';
import { ROUTES } from '../../constants';
import VascoRasp from '../../screens/auth/vasco/vasco-rasp';
import ResetPasswordPage from '../../screens/auth/change-password-from-login'
import InvestmentIdeaHome from '../../screens/investment-ideas/index';
import Details from '../../screens/investment-ideas/details';

import ChangePasswordSuccess from '../../screens/change-password/change-password-success';
import ChangePasswordSettings from '../../screens/change-password/change-password-settings';

import TermsConditions from '../../screens/auth/terms-conditions';
import TransactionSecurityAdviceList from '../../../@extension/CH/src/scenes/portfolio/transactions-global/transaction-security-advice/transaction-security-advice-list';
import ForgotPasswordPage from '../../../@extension/CH/src/screens/auth/forgot-password';
import DataExports from '../../screens/data-exports';
import Transactions from '../../screens/data-exports/custom-transactions';

// RMAccess CH
import LandingPage from '../../screens/rm-access/landing-page';
import RMSearchContainer from '../../screens/rm-access/search';

// Dashboard Summary CH
import DashboardContainer from '../../screens/dashboard';

// DocumentUpload CH
import DocUploadLandingPage from '../../screens/rm-access/doc-upload/doc-upload-landing';
import DocUploadTabContainer from '../../screens/rm-access/doc-upload/doc-upload-tab-container';
import UploadDocumentSearch from '../../screens/rm-access/doc-upload/doc-upload-search';
import UploadDocumentForm from '../../screens/rm-access/doc-upload/doc-upload-form';
import UploadDocumentConditions from '../../screens/rm-access/doc-upload/doc-upload-conditions';
import UploadDocumentFinalize from '../../screens/rm-access/doc-upload/doc-upload-finalize';
import SummaryCashAccounts from '../../screens/cash-accounts/summary-cash-accounts';
import SummaryCashAccountsDetails from '../../screens/cash-accounts/summary-details-cash-accounts';
import SummaryCashAccountsMoreDetails from '../../screens/cash-accounts/summary-cash-accounts-more-details/summary-cash-accounts-more-details';

//PSD2
import AccountAccessRequestSummary from '../../screens/payments/account-information-service';
import PaymentInitiationService from '../../screens/payments/payment-initiation-service';

const routeConfig = {
  ...Extender,
  /* Auth Routes */
  '/login': {
    component: Screens.User.Login,
    section: 'login',
  },

  '/rmAccess': {
    component: LandingPage,
    section: 'rmaccess',
  },

  '/legal': {
    component: AppBlank, // Legal
  },

  '/logout': {
    component: Logout, // Logout
  },

  '/login-faq': {
    component: Screens.User.LoginFaq, // FAQ
    section: 'login',
  },

  '/login-security': {
    component: Screens.User.LoginSecurity, // Security
    section: 'login',
  },

  '/login-contact-us': {
    component: Screens.User.LoginContactUs, // Contact Us
    section: 'login',
  },

  /* WMCE-126  Routes for new page Dashboard Summary */
  '/dashboard': {
    component: DashboardContainer,
    section: 'newDashboard'
  },

   /*  Change password routes starts */
  '/profile/change-password': {   
    component: Screens.ChangePassword,
    section: 'changePassword',
  },
  '/new-user-change-password': {
    component: Screens.ChangePassword,
  },
  '/profile/change-password-settings': {
    component: ChangePasswordSettings,
    section: 'changePassword',
  },
  '/change-password-success': {
    component: ChangePasswordSuccess,  // ChangePasswordSuccess
  },
  '/reset-password': {
    component: ResetPasswordPage,
    section: 'resetPassword',
  },
  '/forgot-password': {
    component: ForgotPasswordPage, // Forgot Password for CH
    section: 'forgotPassword',
  },
  // '/profile/change-password-success': {
  //   component: Screens.ChangePassword.ChangePasswordSuccess,
  //   section: 'changePasswordSuccess',
  // },
  /*  Change password routes ends */

  // '/terms-conditions': {
  //   component: TermsConditions, // TermsConditions
  // },

  // 'login/login-term-condition': {
  //   component: LoginTermsCondition,
  // }

  '/vascorasp': {
    component: VascoRasp,
  },
  '/vascorasp/:event': {
    component: VascoRasp,
  },
  '/webssoconnect': {
    component: WebSSOConnect, // WebSSOConnect
  },

  /* Marquee Admin Routes */
  '/admin': {
    component: Admin, // Admin,
  },

  '/admin/alertmanagement': {
    component: AlertManagement, // AlertManagement,
    section: 'alertmanagement',
  },

  '/admin/alertlist': {
    component: AlertList, // AlertList,
    section: 'alertmanagement',
  },
  /* Marquee Admin Routes End */

  /* RM Call Back* Routes */
  '/rmcallback/:string': {
    component: RMCallBack, // RMCallBack
  },
  /* RM Call Back* Routes End */

  /* Doc Sign Center* Routes */
  '/docsigncenter': {
    component: Screens.DocSignCenter.Home,
    section: 'docsigncenter'
  },
  '/docsigncenter/docdetails': {
    component: Screens.DocSignCenter.DocDetails,
    section: 'docsigncenter'
  },
  '/docsigncenter/docdetails/:docId': {
    component: Screens.DocSignCenter.DocDetails,
    section: 'docsigncenter'
  },

  /* Investment Ideas Routes */
  '/investments': {
    component: InvestmentIdeaHome, // Home
    section: 'investments',
  },

  '/investments/details/:articleid': {
    component: Details,
    section: 'InvestmentIdeas'
  },

  /* Doc Sign Center* Routes End */

  /* Document List* Routes */
  '/docsign/document-list': {
    component: Screens.Docsign.DocumentList,
    section: 'eSignature'
  },
  '/docsign/accept-sign-success': {
    component: Screens.Docsign.AcceptSignSuccessModal,
    section: 'eSignature'
  },
  '/docsign/accept-sign-reject': {
    component: Screens.Docsign.AcceptSignRejectModal,
    section: 'eSignature'
  },
  '/docsign/docusign-response-modal': {
    component: Screens.Docsign.DocusignResponseModal,
    section: 'eSignature',
  },
  /* Document List* Routes End */

  /* CIO Insights Routes */
  '/insights': {
    component: Screens.Insights.Home,
    section: 'insights',
  },
  '/insights/article': {
    component: Screens.Insights.Article, // Article
    section: 'insights',
  },
  '/insights/article/:articleid': {
    component: Screens.Insights.Article, // Article
    section: 'insights',
  },
  /* CIO Insights Routes End */

  /* Notification Routes */
  '/notification': {
    component: AppBlank, // Notification
  },
  /* Notification Routes End */

  /* Credit View Routes */
  '/creditview': {
    component: AppBlank, // CreditView
    section: 'creditview',
  },
  /* Credit View Routes End */

  /* Download Routes */
  '/downloads': {
    component: Screens.Downloads.Home,
    section: 'downloads',
  },
  /* Download Routes End */

  /* Maturities Routes */
  '/maturities': {
    component: Screens.Maturities.MaturitiesHome, // Maturities
    section: 'maturities',
  },
  ...maturityChildRoutes,
  /* Maturities Routes End */

  /* Profile Page */
  '/profile': {
    component: Screens.Settings.Profile,
    section: 'profile',
  },
  '/profile/portfolio': {
    component: Screens.Settings.Portfolio,
    section: 'portfolio',
  },
  '/profile/security': {
    component: Screens.Settings.Security,
    section: 'security',
  },

  '/profile/currency-options': {
    component: Screens.Settings.ProfileCurrencyOptions,
    section: 'currencyOptions',
  },
  '/profile/language-options': {
    component: Screens.Settings.ProfileChangeLanguage,
    section: 'manageDefaultLanguage',
  },
  '/profile/profile-region': {
    component: AppBlank,
    section: 'manageDefaultLanguage',
  },
  '/profile/consolidation-setup': {
    component: Screens.Settings.ConsolidationSetup,
    section: 'manageConsolidation',
  },
  '/profile/notification-setting': {
    component: Screens.Settings.NotificationSettings,
    section: 'notificationSettings',
  },
  '/profile/feedback': {
    component: Screens.Settings.ClientFeedback,
    section: 'provideFeedback',
  },
  '/profile/terms-condition': {
    component: Screens.Settings.TermsCondition,
    section: 'termsCondition',
  },
  '/profile/docsign-subscription': {
    component: Screens.Settings.DocSignSubscription,
    section: 'manageDocSignSubscription',
  },
  '/profile/manage-devices': {
    component: Screens.Settings.ManageDevices,
    section: 'manageDevices',
  },
  '/profile/user-bp-list': {
    component: Screens.Settings.UserBPList,
    section: 'manageContactDetails',
  },
  '/profile/manage-contact-details': {
    component: Screens.Settings.ManageContactDetails,
    section: 'manageContactDetails',
  },
  '/profile/hrmw-form': {
    component: Screens.Settings.HrmwForm,
    section: 'manageContactDetails',
  },
  '/profile/add-contact-details': {
    component: Screens.Settings.AddContactDetails,
    section: 'manageContactDetails',
  },
  '/profile/amend-contact': {
    component: Screens.Settings.AmendContactDetails,
    section: 'manageContactDetails',
  },
  '/profile/paperless-settings': {
    component: Screens.Settings.PaperlessSettings,
    section: 'PaperlessSettings',
  },
  /* Profile Page End */

  /* Portfolio Page */
  '/portfolios': {
    component: Screens.Portfolio.Dashboard,
    section: 'portfolio',
  },
  '/portfolios/income-history': {
    component: Screens.Portfolio.Home, // Home
    section: 'income',
  },

  '/Income-Expense': {
    component: Screens.RootView, // Home
    section: 'income',
  },

  '/portfolios/income-history/transaction/:asset/:summary': {
    component: Screens.Portfolio.Transaction, // transaction
    section: 'income',
  },
  '/portfolios/income-history/transaction/:asset/:summary/:title': {
    component: Screens.Portfolio.Transaction, // transaction
    section: 'income',
  },
  '/portfolios/alternatives': {
    component: Screens.Portfolio.AlternativesPositions, // AlternativesPositions
    assetCategory: 'alternatives',
  },
  '/portfolios/alternatives/:id': {
    component: Screens.Portfolio.AlternativesTransactions, // AlternativesTransactions
    assetCategory: 'alternatives',
    section: 'transactions',
  },
  '/portfolios/cash': {
    component: Screens.Portfolio.CashPositions, // CashPositions
    assetCategory: 'cash',
  },
  '/portfolios/cash/:id': {
    component: Screens.Portfolio.CashTransactions, // CashTransactions
    assetCategory: 'cash',
    section: 'transactions',
  },
  '/portfolios/bonds': {
    component: Screens.Portfolio.BondsPositions, // BondsPositions
    assetCategory: 'bonds',
  },
  '/portfolios/bonds/:id': {
    component: Screens.Portfolio.BondsTransactions, // BondsTransactions
    assetCategory: 'bonds',
    section: 'transactions',
  },
  '/portfolios/equities': {
    component: Screens.Portfolio.EquitiesPositions, // EquitiesPositions
    assetCategory: 'equities',
  },
  '/portfolios/equities/:id': {
    component: Screens.Portfolio.EquitiesTransactions, // EquitiesTransactions
    assetCategory: 'equities',
    section: 'transactions',
  },
  '/portfolios/optionsDerivatives': {
    component: Screens.Portfolio.OptionsDerivativesPositions, // OptionsDerivativesPositions
    assetCategory: 'optionsDerivatives',
  },
  '/portfolios/optionsDerivatives/:id': {
    component: Screens.Portfolio.OptionsDerivativesTransactions, // OptionsDerivativesTransactions
    assetCategory: 'optionsDerivatives',
    section: 'transactions',
  },
  '/portfolios/loans': {
    component: Screens.Portfolio.LoansPositions, // LoansPositions
    assetCategory: 'loans',
  },
  '/portfolios/loans/:id': {
    component: Screens.Portfolio.LoansTransactions, // LoansTransactions
    assetCategory: 'loans',
    section: 'transactions',
  },
  '/portfolios/mmInstruments': {
    component: Screens.Portfolio.MMInstrumentsPositions, // MMInstrumentsPositions
    assetCategory: 'mmInstruments',
  },
  '/portfolios/mmInstruments/funds/:id': {
    component: Screens.Portfolio.MMInstrumentsFundsTransactions, // MMInstrumentsFundsTransactions
    assetCategory: 'mmInstruments',
    section: 'transactions',
  },
  '/portfolios/mmInstruments/deposits/:id': {
    component: Screens.Portfolio.MMInstrumentsDepositsTransaction, // MMInstrumentsDepositsTransaction
    assetCategory: 'mmInstruments',
    section: 'transactions',
  },
  '/portfolios/fxForwards': {
    component: Screens.Portfolio.FxForwardsPositions, // FxForwardsPositions
    assetCategory: 'fxForwards',
  },
  '/portfolios/fxForwards/:id': {
    component: Screens.Portfolio.FxForwardsTransactions, // FxForwardsTransactions
    assetCategory: 'fxForwards',
    section: 'transactions',
  },
  '/portfolios/various': {
    component: Screens.Portfolio.VariousPositions, // VariousPositions
    assetCategory: 'various',
  },
  '/portfolios/various/:id': {
    component: Screens.Portfolio.VariousTransactions, // VariousTransactions
    assetCategory: 'various',
    section: 'transactions',
  },
  '/portfolios/transactionAdvice': {
    component: Screens.Portfolio.TransactionAdvice, // TransactionAdvice
    section: 'transactionAdvice',
  },
  '/advices': {
    component: TransactionSecurityAdviceList,
  },
  /* Portfolio Page End */

  /* Search Route */
  '/search': {
    component: Search, // Search
  },
  /* Search Route End */

  /* DataExports Routes */
  '/dataExports': {
    component: DataExports, // Data Exports
    section: 'dataExports',
  },

  /* Cash Accounts Routes */
  [ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_ROUTE]: {
    component: SummaryCashAccounts,
    section: 'cashAccounts',
  },

  [ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_DETAILS_ROUTE]: {
    component: SummaryCashAccountsDetails, // CashAccountsDetails
    section: 'cashAccountsDetails',
  },

  [ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_MORE_DETAILS]: {
    component: SummaryCashAccountsMoreDetails, // SummaryCashAccountsMoreDetails 
    section: 'cashAccountsMoreDetails',
  },

  /* Cash Accounts Routes End */

  /* Transactions Routes */
  '/transactions': {
    component: Transactions, // Transactions
    section: 'transactions',
  },


  /* Report Routes */
  '/reports': {
    component: Reports, // Reports
    section: 'reports',
  },
  '/reports/monthlyStatemt': {
    component: Screens.Reports.MonthlyStatement, // MonthlyStatement
    section: 'monthlyStatemt',
  },

  '/reports/income-history': {
    component: Screens.Reports.Home, // Home
    section: 'income',
  },
  '/reports/dailyStatement': {
    component: Screens.Reports.DailyStatement, // DailyStatement
    section: 'dailyStatement',
  },
  '/reports/transaction': {
    component: TransactionHistory, // TransactionHistory
    section: 'transaction',
  },
  '/reports/advicesStatements': {
    component: Screens.Reports.AdvicesStatements, // AdvicesStatements
    section: 'advices',
  },
  '/reports/adviceStatement': {
    component: Screens.Reports.AdviceStatement, // AdviceStatement
    section: 'advices',
  },
  '/reports/monthStatement': {
    component: Screens.Reports.MonthStatement, // MonthStatement
    section: 'month',
  },
  '/reports/dailyPdfLists': {
    component: Screens.Reports.DailyPdfLists, // DailyPdfLists
    section: 'dailyStatement',
  },
  '/reports/currentMonthlyStatement': {
    component: Screens.Reports.CurrentMonthlyStatement, // CurrentMonthlyStatement
    section: 'currentMonthlyStatements',
  },
  '/reports/currentMonthStatement': {
    component: Screens.Reports.CurrentMonthStatement, // CurrentMonthStatement
    section: 'currentMonthStatement',
  },
  '/reports/CorrespondenceStatement': {
    component: Screens.Reports.CorrespondenceStatement, // CorrespondenceStatement
    section: 'CorrespondenceStatement',
  },
  '/reports/CorrespondencePdfLists': {
    component: Screens.Reports.CorrespondencePdfLists, // CorrespondencePdfLists
    section: 'CorrespondenceStatement',
  },
  /* Report Routes */

  /* Payment Routes */
  [ROUTES.PAYMENT.DASHBOARD]: {
    component: Screens.Payments.Dashboard,
    section: 'payments',
  },
  [ROUTES.PAYMENT.DESTINATION]: {
    component: Screens.Payments.paymentDestination,
    section: 'Select Beneficiary',
  },
  [ROUTES.PAYMENT.TX_SUMMARY]: {
    component: Screens.Payments.PaymentSummary,
    section: 'Domestic Payment Summary',
  },
  [ROUTES.PAYMENT.NEW_DOMESTIC]: {
    component: Screens.Payments.PymtDomNew,
    section: 'New Domestic Payment',
  },
  [ROUTES.PAYMENT.DEBIT_ACCOUNT_LIST]: {
    component: Screens.Payments.DebitAccountList,
    section: 'Select Debit Account',
  },
  [ROUTES.PAYMENT.CONFIRMATION]: {
    component: Screens.Payments.PaymentConfirmation,
    section: 'Payment Confirmation',
  },
  [ROUTES.PAYMENT.ADD_BENEFICIARY]: {
    component: Screens.Payments.PymtBenefAdd,
    section: 'Beneficiary Details',
  },
  [ROUTES.PAYMENT.LOADING]: {
    component: Screens.Payments.paymentsLoader,
    section: 'Payment Loader',
  },
  [ROUTES.PAYMENT.FILTER]: {
    component: Screens.Payments.PaymentFilter,
    section: 'Payment Filter',
  },
  [ROUTES.PAYMENT.TEMPLATE]: {
    component: Screens.Payments.PaymentTemplate,
    section: 'Payment Template'
  },
  /* Payment Routes End  */

  /* RMAccess Routes */
  '/rm-access/search': {
    component: RMSearchContainer,
    section: 'RMAccessSearch',
  },
  /* RMAccess Routes End */

  /* DocumentUpload Routes */
  [ROUTES.RMACCESS.DOC_LANDING_PAGE]: {
    component: DocUploadLandingPage,
    section: 'DocUploadLandingPage',
  },
  [ROUTES.RMACCESS.DOC_TAB_CONTAINER]: {
    component: DocUploadTabContainer,
    section: 'DocUploadTabContainer',
  },
  [ROUTES.RMACCESS.DOC_SEARCH]: {
    component: UploadDocumentSearch,
    section: 'UploadDocumentSearch',
  },
  [ROUTES.RMACCESS.DOC_FORM]: {
    component: UploadDocumentForm,
    section: 'UploadDocumentForm',
  },
  [ROUTES.RMACCESS.DOC_CONDITIONS]: {
    component: UploadDocumentConditions,
    section: 'UploadDocumentConditions',
  },
  [ROUTES.RMACCESS.DOC_FINALIZE]: {
    component: UploadDocumentFinalize,
    section: 'UploadDocumentFinalize',
  },
  [ROUTES.RMACCESS.DOC_TAB_CONTAINER_FAQ]: {
    component: Screens.User.LoginFaq
  },
  [ROUTES.RMACCESS.DOC_TAB_CONTAINER_SEQURITY]: {
    component: Screens.User.LoginSecurity
  },

  '/psd2/aisflow':{
    component: AccountAccessRequestSummary,
    section: 'PSD2'
  },
  '/psd2/pisflow':{
    component: PaymentInitiationService,
    section: 'PSD2'
  },


  /* DocumentUpload Routes End */

  /* Auth Routes End */
  '/loadportfolio': {
    component: Screens.PortfolioRedirect,
  },
  '/': {
    component: Screens.LoadingViewPublic,
  },

  '/rsaredirect': {
    component: Screens.RsaRedirect,
  },

  '/loadingview': {
    component: Screens.LoadingView,
  },

  '/loading': {
    component: Screens.LoadingViewPublic,
  },
  [ROUTES.TRADE.LIBRARY]: {
    component: Screens.TradeLibrary,
  },

  '*': {
    component: Screens.RootView // AppBlank,
  },
};

const enhance = (props) => ({ component: Component, ...customProps }) => () => (
  <Component {...props} {...customProps} />
);

const getRoutes = (props) => {
  const enhanceWithParentProps = enhance(props);

  return reduce(
    routeConfig,
    (accRoute, route, key) => {

      let baseKey = key;

      if (settings.webfolder && settings.webfolder.trim().length > 0) {
        baseKey = key === '*' ? `${key}` : `/${settings.webfolder}${key}`;
      }

      accRoute[baseKey] = routeConfig[key];
      accRoute[baseKey].component = enhanceWithParentProps(accRoute[baseKey]);
      return accRoute;
    },
    {}
  );
};

export { getRoutes };

export default routeConfig;
